import POITable from './POITable';
import {Point} from 'ol/geom';
import './PopUp.css';
import _ from 'lodash';
export default function PopUp(props){

    function changeformat(val){
        if(val==='NRM'){
            return 'Arena';
        }else if(val==='EXC'){
            return 'Nexa';
        }
    }
    function changeSecondFormat(val){
        if(val==='O'){
            return 'M';
        }
        else return val;
    }

    // console.log("showing props->",props?.f?.values_?.channel);
    console.log("showing props->",props?.f?.values_);
    return(
        <div id="popup" ref = {props?.popupElement} className="ol-popup">
        <a href="#" id="popup-closer" ref = {props?.closerElement} className="ol-popup-closer"></a>
        <div id="popup-content">
        {props?.f?.values_?.geometry instanceof Point  ? <div className="popup-content">


            <h5>{props?.f?.values_?.MSIL_CODE}</h5>
            <p>{props?.f?.values_?.POI_NAME}</p>
            <h6>{props?.f?.values_?.dealer_name}</h6> 
             {/* {props?.f?.values_?.dealer_name && <p>Parent : {props?.f?.values_?.parent_group}</p>} */}
             {props?.f?.values_?.dealer_name && <p style={{'fontSize':"0.875rem"}}>Dealer Code : {props?.f?.values_?.dealer_code}</p>}
             {/* {props?.f?.values_?.dealer_name && <p>Type : {changeformat(props?.f?.values_?.channel)} , {changeSecondFormat(props?.f?.values_?.outlet_type)}</p>} */}
             {props?.f?.values_?.dealer_name && <p style={{'fontSize':"0.875rem"}}>Type : {props?.f?.values_?.channel}</p>}
             {/* {props?.f?.values_?.dealer_name && <p>Address-<p className='address-font'>{props?.f?.values_?.dealer_detail}</p></p>} */}



            
            </div>
            : <POITable POI = {props?.POI} f = {props?.f} />}
        
        </div>
        </div>
    )
}